import { useNotificationContext } from "src/context/notification-context";

export function useNotifications() {
  const ctx = useNotificationContext();

  if (!ctx) {
    throw new Error("useNotifications must be used inside NotificationProvider");
  }

  return ctx;
}